/**
 * CSS value for `--main-sidebar-current-width` so fixed UI (bulk action
 * drawer) can sit beside the main nav instead of under it.
 */
export function mainSidebarCurrentWidthValue(collapsed: boolean): string {
	return collapsed
		? 'var(--main-sidebar-collapsed-width)'
		: 'var(--main-sidebar-expanded-width)';
}
